import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/authContext';
import './FloatingNavigation.css';
import {
  FaBars,
  FaTimes,
  FaTachometerAlt,
  FaStickyNote,
 
  FaUserFriends,
  FaKey,
  FaSignOutAlt,
  FaTicketAlt,
  FaEye
} from 'react-icons/fa';

const TeamFloatingNavigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { logout, user } = useAuth();

  // Navigation items grouped by sections - Team specific
  const navigationSections = [
    {
      title: 'Dashboard',
      items: [
        { title: 'Team Dashboard', icon: <FaTachometerAlt />, path: '/team-dashboard' }
      ]
    },
    {
      title: 'Sales Management',
      items: [
        { title: 'Sales Overview', icon: <FaEye />, path: '/viewSale' },
        { title: 'Add Sale', icon: <FaTicketAlt />, path: '/addSale' }
      ]
    },
    {
      title: 'Team Operations',
      items: [
        { title: 'Add Note', icon: <FaStickyNote />, path: '/add-note' },
        { title: 'Add Guide', icon: <FaUserFriends />, path: '/add-guide' },
       
      ]
    }
  ];

  const handleNavigation = (path) => {
    navigate(path);
    setIsOpen(false);
  };

  const handleLogout = () => {
    logout();
    navigate('/');
    setIsOpen(false);
  };

  const isActive = (path) => location.pathname === path;

  return (
    <>
      {/* Floating Menu Button */}
      <div className="fixed bottom-6 right-6 z-50">
        <button
          onClick={() => setIsOpen(!isOpen)}
          className={`
            floating-button w-14 h-14 bg-blue-600 hover:bg-blue-700 text-white rounded-full shadow-lg
            flex items-center justify-center transition-all duration-300 opacity-75 hover:opacity-100
            backdrop-blur ${isOpen ? 'rotate-180' : 'rotate-0'}
          `}
        >
          {isOpen ? <FaTimes className="text-xl" /> : <FaBars className="text-xl" />}
        </button>
      </div>

      {/* Modal Overlay */}
      {isOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-20 z-40"
          onClick={() => setIsOpen(false)}
        />
      )}

      {/* Navigation Modal */}
      <div className={`
        fixed bottom-24 right-6 w-80 bg-white rounded-xl border border-slate-200 z-50
        floating-modal-shadow transform transition-all duration-300 origin-bottom-right
        ${isOpen ? 'scale-100 opacity-100' : 'scale-0 opacity-0 pointer-events-none'}
      `}>
        {/* Modal Header */}
        <div className="flex items-center justify-between p-4 border-b border-slate-200 bg-slate-50 rounded-t-xl">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-gradient-to-br from-green-500 to-green-700 rounded-full flex items-center justify-center text-white font-semibold text-base">
              {user?.name?.charAt(0)?.toUpperCase() || user?.username?.charAt(0)?.toUpperCase() || 'U'}
            </div>
            <div>
              <p className="text-base font-semibold text-slate-800">{user?.name || user?.username || 'User'}</p>
              <p className="text-xs text-slate-500">{user?.role || 'Team'}</p>
            </div>
          </div>
          <button
            onClick={() => setIsOpen(false)}
            className="p-1 hover:bg-slate-200 rounded-md transition-colors"
          >
            <FaTimes className="text-slate-500 text-sm" />
          </button>
        </div>

        {/* Navigation Content */}
        <div className="max-h-96 overflow-y-auto p-2 floating-nav-scroll">
          {navigationSections.map((section, sectionIndex) => (
            <div key={sectionIndex} className="mb-4">
              <h3 className="text-xs font-semibold text-slate-500 uppercase tracking-wider px-3 py-2">
                {section.title}
              </h3>
              <div className="space-y-1">
                {section.items.map((item, itemIndex) => (
                  <button
                    key={itemIndex}
                    onClick={() => handleNavigation(item.path)}
                    className={`
                      w-full flex items-center px-3 py-2.5 text-sm font-medium rounded-lg
                      transition-all duration-200 text-left
                      ${isActive(item.path)
                        ? 'bg-green-100 text-green-700 border-l-3 border-green-500'
                        : 'text-slate-600 hover:bg-slate-100 hover:text-slate-800'
                      }
                    `}
                  >
                    <span className={`mr-3 ${isActive(item.path) ? 'text-green-500' : 'text-slate-400'}`}>
                      {item.icon}
                    </span>
                    {item.title}
                    {isActive(item.path) && (
                      <span className="ml-auto w-2 h-2 bg-green-500 rounded-full"></span>
                    )}
                  </button>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Modal Footer */}
        <div className="border-t border-slate-200 p-3 bg-slate-50 rounded-b-xl space-y-1">
          <button
            onClick={() => handleNavigation('/change-password')}
            className="w-full flex items-center px-3 py-2.5 text-sm font-medium text-green-600 hover:text-green-700 hover:bg-green-50 rounded-lg transition-all duration-200"
          >
            <FaKey className="mr-3" />
            Change Password
          </button>
          <button
            onClick={handleLogout}
            className="w-full flex items-center px-3 py-2.5 text-sm font-medium text-red-600 hover:text-red-700 hover:bg-red-50 rounded-lg transition-all duration-200"
          >
            <FaSignOutAlt className="mr-3" />
            Logout
          </button>
        </div>
      </div>
    </>
  );
};

export default TeamFloatingNavigation;
